import { render, staticRenderFns } from "./itemview.vue?vue&type=template&id=7408ad66&scoped=true"
import script from "./itemview.vue?vue&type=script&lang=js"
export * from "./itemview.vue?vue&type=script&lang=js"
import style0 from "./itemview.vue?vue&type=style&index=0&id=7408ad66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408ad66",
  null
  
)

export default component.exports